import React from "react";
import { Calendar, Award, Users, Sparkles } from 'lucide-react';

interface HeroProps {
  scrollToSection: (sectionId: string) => void;
}

function Hero({ scrollToSection }: HeroProps) {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-black"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-pink-300 rounded-full mix-blend-lighten filter blur-xl opacity-20 animate-pulse"></div>
      <div className="absolute bottom-20 left-10 w-72 h-72 bg-pink-400 rounded-full mix-blend-lighten filter blur-xl opacity-15 animate-pulse" style={{ animationDelay: "1s" }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center bg-pink-300/20 text-pink-300 border border-pink-300/30 px-4 py-2 rounded-full text-sm font-medium mb-6">
              <Sparkles className="w-4 h-4 mr-2" />
              Профессиональное ведение мероприятий
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Создаю незабываемые
              <span className="text-pink-300"> моменты</span> для любого события
            </h1>

            <p className="text-lg text-gray-300 mb-8 max-w-2xl font-medium">Зовут меня Алисия Беатрис,
я - ведущая.
Училась в Рати (Гитис) и в колледже (муз.училище эстрадного и джазового искусства.)

Если Вам нужны ведущие, с которыми ваше мероприятие пройдет на "ура" - интересно и весело, а гости останутся довольны - Вы на той странице!

Провожу мероприятия на разных площадках независимо от их тем и названий.
Мой подход к проведению универсален, я составляю тайминг, учитывая все пожелания, чтобы обеспечить "гладкое" проведение праздника.
Обладаю хорошей коммуникабельностью, имею навыки общения с людьми разных характеров и возрастов.
Адаптируюсь к конкретным и даже уникальным запросам и пожеланиям.
Стараюсь оставить приятное впечатление у людей разных профессий, увлечений и статусов.

Вы в поиске ведущего который знает, как устроить праздник? Она здесь. Обращайтесь и у нас получится!</p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              <button onClick={() => scrollToSection("contact")} className="bg-pink-300 text-black px-8 py-4 rounded-lg font-semibold hover:bg-pink-400 transition shadow-lg shadow-pink-300/20 hover:shadow-pink-300/40 transform hover:-translate-y-0.5">Написать мне

              </button>
              <button onClick={() => scrollToSection("portfolio")} className="bg-transparent text-white px-8 py-4 rounded-lg font-semibold hover:bg-pink-300/10 transition border-2 border-pink-300">Смотреть портфолио


              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 max-w-md mx-auto lg:mx-0">
              <div className="text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start mb-2">
                  <Calendar className="w-6 h-6 text-pink-300" />
                </div>
                <div className="text-3xl font-bold text-white">500+</div>
                <div className="text-sm text-gray-400">успешных мероприятий </div>
              </div>
              <div className="text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start mb-2">
                  <Users className="w-6 h-6 text-pink-300" />
                </div>
                <div className="text-3xl font-bold text-white">5K+</div>
                <div className="text-sm text-gray-400">довольных гостей</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start mb-2">
                  <Award className="w-6 h-6 text-pink-300" />
                </div>
                <div className="text-3xl font-bold text-white">5+ лет</div>
                <div className="text-sm text-gray-400">Опыт работы</div>
              </div>
            </div>
          </div>

          {/* Right Content - Host Photo */}
          <div className="relative">
            <div className="relative w-full max-w-lg mx-auto">
              {/* Decorative background shape */}
              <div className="absolute inset-0 bg-gradient-to-br from-pink-300 to-pink-400 rounded-3xl transform rotate-6"></div>
              
              {/* Main image container */}
              <div className="relative bg-gray-900 p-2 rounded-3xl shadow-2xl shadow-pink-300/10">
                <img src="https://cdn-static-lumi.artvibe.ai/92/927f5116e179c452c32f2695329248cd.jpg" alt="Professional Event Host" className="w-full h-[500px] object-cover rounded-2xl"></img>

                
                {/* Floating badge */}
                <div className="absolute -bottom-6 -right-6 bg-black p-6 rounded-2xl shadow-xl border-4 border-pink-300">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-pink-300">4.9★</div>
                    <div className="text-sm text-gray-300 font-medium">Оценка</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}

export default Hero;